import { render, staticRenderFns } from "./BtnConsulter.vue?vue&type=template&id=8c551492&lang=html&"
import script from "./BtnConsulter.vue?vue&type=script&lang=js&"
export * from "./BtnConsulter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports